module.exports = __webpack_public_path__ + "img/aurelia_logo.0c615c73.png";